<template>
    <div class="main">
        <van-swipe :autoplay="3000" :touchable="true" :show-indicators="false" ref="swiper">
            <van-swipe-item v-for="(item, index) in images" :key="index">
                <img v-lazy="item" style="width: 100%;height: 100vh;" />
            </van-swipe-item>
        </van-swipe>
        <div class="actionIcon">
            <div class="icons">
                <img src="../../../src/static/imgs/left.png" class="img" @click="handleLeft('up')" />
                <img src="../../../src/static/imgs/right.png" class="img" @click="handleRight('down')" />
            </div>
        </div>
        <div class="gymaMain">
            <div class="left">
                <img src="../../static/imgs/logo2.png" class="logoImg" />
                <div class="name">关于铭安</div>
                <div class="ms">ABOUT US</div>
                <div class="text">
                    浙江铭安潮居智能科技有限公司（简称“铭安潮居”）是专注于城乡绿色建筑和绿色能源业务的产业互联网企业。公司以钢结构别墅与户用光伏为切入点，通过标准化的产品、智能化的工具、属地化的服务，为终端业主提供高品质的绿色用能和居住产品。目前业务范围已覆盖浙江、安徽、江苏、福建、山东、河北、河南等区域。
                </div>
                <div class="share" @click="handleGyma">
                    <div class="shareText">了解更多</div>
                    <img src="../../static/imgs/share2.png" class="shareImg" />
                </div>
            </div>
            <div class="spMain">
                <video src="https://macj.oss-cn-hangzhou.aliyuncs.com/%E5%AE%A3%E4%BC%A0%E7%89%87.mp4" controls
                    width="880px" height="587px"></video>
            </div>
        </div>
        <div class="zyyyMain">
            <div class="titleName">主营业务</div>
            <div class="ywms">ABOUT US</div>
            <div class="ywContent">
                <div class="ywLeftMain" v-if="ywIndex == 1" @click="handleYw">
                    <div class="content">
                        <img src="../../static/imgs/ywIcon1.png" class="icon" />
                        <div class="ywName">绿色建筑</div>
                        <div class="ywText">让高品质民居走进千家万户</div>
                    </div>
                </div>
                <div class="ywLeftMainRe" v-if="ywIndex == 0">
                    <div class="content">
                        <img src="../../static/imgs/ywIcon2.png" class="icon" />
                        <div class="ywNameRe">绿色建筑</div>
                        <div class="ywTextRe">让高品质民居走进千家万户</div>
                        <div class="ywShare" @click="handleLsjz">
                            <div class="ywShareText">了解更多</div>
                            <img src="../../static/imgs/ywShare.png" class="ywShareImg" />
                        </div>
                    </div>
                </div>
                <div class="ywnyftMainRe" v-if="ywIndex == 1">
                    <div class="content">
                        <img src="../../static/imgs/ywIcon4.png" class="icon" />
                        <div class="ywNameRe">绿色能源</div>
                        <div class="ywTextRe">工商业光伏 | 户用纯租 | 整县推进</div>
                        <div class="ywShare" @click="handleLsny">
                            <div class="ywShareText">了解更多</div>
                            <img src="../../static/imgs/ywShare.png" class="ywShareImg" />
                        </div>
                    </div>
                </div>
                <div class="ywnyftMain" v-if="ywIndex == 0" @click="handleYwTo">
                    <div class="content">
                        <img src="../../static/imgs/ywIcon3.png" class="icon" />
                        <div class="ywName">绿色能源</div>
                        <div class="ywText">工商业光伏 | 户用纯租 | 整县推进</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="xwzxMain">
            <div class="titleName" style="color: #000;">新闻资讯</div>
            <div class="ywms" style="color: #999999;">NEWS CENTER</div>
            <div class="contentXw">
                <a :href="listData[0].contentUrl" target="_blank">
                    <div class="xwzxLeft">
                        <img :src="listData[0].newsImg[0]" class="xwImg" />
                        <div class="back">
                            <div class="xwName">{{ listData[0].title }}</div>
                            <div class="textMs">
                                {{ listData[0].des }}
                            </div>
                            <div class="time">{{ listData[0].startTime }}</div>
                        </div>
                    </div>
                </a>
                <div class="rightContent">
                    <a :href="listData[1].contentUrl" target="_blank">
                        <div class="xwzxRight">
                            <img :src="listData[1].newsImg[0]" class="xwImgs" />
                            <div class="contentMs">
                                <div class="xwNames">{{ listData[1].title }}</div>
                                <div class="textMsa">
                                    {{ listData[1].des }}
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="listData[2].contentUrl" target="_blank">
                        <div class="xwzxRight" style="margin-top: 16px;">
                            <img :src="listData[2].newsImg[0]" class="xwImgs" />
                            <div class="contentMs">
                                <div class="xwNames">{{ listData[2].title }}</div>
                                <div class="textMsa">
                                    {{ listData[2].des }}
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="listData[3].contentUrl" target="_blank">
                        <div class="xwzxRight" style="margin-top: 16px;">
                            <img :src="listData[3].newsImg[0]" class="xwImgs" />
                            <div class="contentMs">
                                <div class="xwNames">{{ listData[3].title }}</div>
                                <div class="textMsa">
                                    {{ listData[3].des }}
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="ywShares" @click="handleXw">
                <div class="ywShareText" style="color: #114035;">了解更多</div>
                <img src="../../static/imgs/jt.png" class="ywShareImg" />
            </div>
        </div>
        <TabListCon :divType="divTypes"></TabListCon>
        <BottomContentCon></BottomContentCon>
    </div>
</template>
<script>
import TabListCon from "../../components/TabList/index.vue"
import { articlesList } from "@/utils/api";//调接口引入
import BottomContentCon from "../../components/BottomContent/index.vue"

//http://121.5.230.236:1108/boot  直接复制这个编辑器上全部替换就可 测试了下 封装的 没问题 
export default {
    name: "Home",
    data() {
        return {
            total: -1,
            pageLeng: -1,
            divTypes: '4',//顶部Tab组件的index值
            listData: [],
            listQuery: {
                categoryId: 1,
                pageNo: 1,
                pageSize: 5,
            },
            currentPage: 1,
            pageSize: 5,
            ywIndex: 0,
            divTypes: '1',//顶部Tab组件的index值
            //轮播图数组 轮播因为双端适配自动滑动和手工鼠标和手机屏幕滑动 到顶继续从新开始 
            images: [
                require('../../static/imgs/ba1.jpg'),
                require('../../static/imgs/ba2.jpg'),
                require('../../static/imgs/ba3.jpg'),
            ],
        }
    },
    components: { TabListCon, BottomContentCon },
    created() {
        this.divTypes = '1'
        this.newsInformationData()
    },
    methods: {
        handleGyma() {
            this.$router.push("/AboutMingAn")
        },
        handleXw() {
            this.$router.push("/NewsInformation")
        },
        newsInformationData() {
            articlesList(this.listQuery).then(res => {
                const { data, code, message } = res
                if (code == 0) {
                    this.listData = data.list
                    this.total = data.total
                    this.pageLeng = Math.ceil(data.total / this.pageSize)

                } else {
                    this.$toast.fail(message);
                }
            })
        },
        handleYwTo() {
            this.ywIndex = 1
        },
        handleYw() {
            this.ywIndex = 0
        },
        handleLsny() {
            this.$router.push("/HealthBusiness")
        },
        handleLsjz() {
            this.$router.push("/BusinessBuilding")
        },
        //可以无兼容问题
        handleLeft() {
            this.$refs.swiper.prev()
        },
        handleRight() {
            this.$refs.swiper.next()
        }
        //点击轮播切换按钮 使用兼容原生方法 理论上没问题 此原生方法备用 多端兼容  
        // handleIcon(type){
        //   if(type == "up") this.index -= 1
        //   if(type == "down") this.index += 1
        //   this.$refs.swiper.swipeTo(this.index) 
        //   //cao shab
        // }

    }
};
</script>

<style scoped>
body {
    background-color: none;
}

.back {
    background-color: #FFFFFF;
}

.xwzxRight {
    display: flex;
    height: 230px;
    align-items: center;
}

.xwNames {
    font-size: 32px;
    color: #333333;
    font-weight: bold;
    width: 449px;
    margin: 0 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contentMs {
    background-color: #FFFFFF;
    width: 545px;
    height: 231px;
    padding: 48px;

}

.xwImgs {
    width: 320px;
    height: 231px;
}

.time {
    font-size: 19px;
    color: #6D6D6D;
    line-height: 32px;
    text-align: left;
    font-size: 21px;
    width: 624px;
    padding-top: 32px;
    margin: 0 auto;
}

.textMs {
    font-size: 21px;
    color: #6D6D6D;
    line-height: 43px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    width: 624px;
    padding-top: 36px;
    margin: 0 auto;
}

.textMsa {
    font-size: 21px;
    color: #6D6D6D;
    line-height: 43px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    width: 449px;
    padding-top: 32px;
    margin: 0 auto;
}

.xwName {
    font-size: 33px;
    color: #333333;
    font-weight: bold;
    width: 624px;
    margin: 0 auto;
    margin-top: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.xwzxLeft {
    width: 720px;
    height: 721px;
    background-color: #FFFFFF
}

.contentXw {
    margin-top: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.xwImg {
    width: 720px;
    height: 436px;
}

.ywContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ywShare {
    padding: 0 32px;
    width: 184px;
    height: 56px;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid rgba(247, 235, 192, 0.6);
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 32px;
}

.ywShares {
    padding: 0 32px;
    width: 184px;
    height: 56px;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #114035;
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 64px;
}

.ywShareText {
    font-size: 21px;
    color: #F7EBC0;
    line-height: 21px;
    text-align: center;
}

.ywShareImg {
    width: 32px;
    height: 32px;
    display: block;
}

.content {
    margin: 0 auto;
    margin-top: 134px;
}

.ywText {
    font-size: 21px;
    color: #FFFFFF;
    margin: 0 auto;
    margin-top: 28px;
    width: 360px;
    text-align: center;
}

.ywName {
    font-size: 40px;
    color: #FFFFFF;
    margin: 0 auto;
    font-weight: bold;
    margin-top: 24px;
    width: 160px;
    text-align: center;
}

.icon {
    width: 80px;
    margin: 0 auto;
    height: 80px;
    display: block;
}

.ywTextRe {
    font-size: 21px;
    color: #F7EBC0;
    margin: 0 auto;
    margin-top: 28px;
    width: 360px;
    text-align: center;
}

.ywNameRe {
    font-size: 40px;
    color: #F7EBC0;
    margin: 0 auto;
    font-weight: bold;
    margin-top: 24px;
    width: 160px;
}


.ywLeftMain {
    display: flex;
    margin: auto 0;
    margin-top: 111px;
    width: 768px;
    height: 563px;
    background-size: 563px 768px;
    /* 加载背景图 */
    background-image: url('../../static/imgs/yw1.png');
    /* 背景图垂直、水平均居中 */
    background-position: center center;
    /* 背景图不平铺 */
    background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    /* background-attachment: fixed; */
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
    /* 设置背景颜色，背景图加载过程中会显示背景色 */
    background-color: #464646;
}

.ywnyftMain {
    display: flex;
    margin: auto 0;
    margin-top: 111px;
    width: 768px;
    height: 563px;
    background-size: 563px 768px;
    /* 加载背景图 */
    background-image: url('../../static/imgs/yw2.png');
    /* 背景图垂直、水平均居中 */
    background-position: center center;
    /* 背景图不平铺 */
    background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    /* background-attachment: fixed; */
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
    /* 设置背景颜色，背景图加载过程中会显示背景色 */
    /* background-color: #464646; */
}

.ywLeftMainRe {
    display: flex;
    margin: auto 0;
    margin-top: 111px;
    width: 768px;
    height: 563px;
    background-size: 563px 768px;
    /* 加载背景图 */
    background-image: url('../../static/imgs/ywRe1.png');
    /* 背景图垂直、水平均居中 */
    background-position: center center;
    /* 背景图不平铺 */
    background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    /* background-attachment: fixed; */
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
    /* 设置背景颜色，背景图加载过程中会显示背景色 */
    background-color: #464646;
}

.ywnyftMainRe {
    display: flex;
    margin: auto 0;
    margin-top: 111px;
    width: 768px;
    height: 563px;
    background-size: 563px 768px;
    /* 加载背景图 */
    background-image: url('../../static/imgs/ywRe2.png');
    /* 背景图垂直、水平均居中 */
    background-position: center center;
    /* 背景图不平铺 */
    background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    /* background-attachment: fixed; */
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
    /* 设置背景颜色，背景图加载过程中会显示背景色 */
    background-color: #464646;
}

.ywms {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 27px;
    line-height: 40px;
    color: #FFFFFF;
    text-align: center;
}

.titleName {
    font-size: 64px;
    color: #FFFFFF;
    text-align: center;
    font-weight: bold;
}

.mpSp {
    width: 880px;
    height: 587px;
}

.shareText {
    font-size: 21px;
    color: #114035;
    font-weight: bold;
}

.share {
    display: flex;
    align-items: center;
    padding: 17px 32px;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #114035;
    width: 195px;
    height: 54px;
}

.shareImg {
    width: 32px;
    height: 32px;
    display: block;
    margin-left: 12px;
}

.text {
    width: 503px;
    color: #6D6D6D;
    font-size: 20px;
    line-height: 32px;
    margin-top: 64px;
    margin-bottom: 64px;
}

.ms {
    font-size: 27px;
    color: #999999;
}

.logoImg {
    width: 146px;
    height: 78px;
    margin-top: 36px;
    margin-bottom: 36px;
}

.name {
    font-size: 64px;
    color: #333333;
    font-weight: bold;
}

.gymaMain {
    padding: 140px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 60px;
    /* 加载背景图 */
    background-image: url('../../static/imgs/syBg1.png');
    /* 背景图垂直、水平均居中 */
    background-position: center center;
    /* 背景图不平铺 */
    background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    /* background-attachment: fixed; */
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
    /* 设置背景颜色，背景图加载过程中会显示背景色 */
    background-color: #464646;
}

.zyyyMain {
    padding: 140px;
    /* 加载背景图 */
    background-image: url('../../static/imgs/syBg2.png');
    /* 背景图垂直、水平均居中 */
    background-position: center center;
    /* 背景图不平铺 */
    background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    background-attachment: fixed;
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
    /* 设置背景颜色，背景图加载过程中会显示背景色 */
    background-color: #464646;
}

.xwzxMain {
    padding: 140px;
    /* 加载背景图 */
    background-image: url('../../static/imgs/xwzx1.png');
    /* 背景图垂直、水平均居中 */
    background-position: center center;
    /* 背景图不平铺 */
    background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    background-attachment: fixed;
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
    /* 设置背景颜色，背景图加载过程中会显示背景色 */
    /* background-color: #464646; */
}

.img {
    width: 48px;
    height: 48px;
}

.icons {
    width: 220px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.actionIcon {
    display: flex;
    justify-content: center;
    margin-top: -100px;
    z-index: 999;
    position: relative;
}
</style>